import * as types from "./mutation-types";

const mutations = {
  [types.SET_LOADED_STATUS](state, data) {
    state[data.key] = data.value;
  },

  [types.SET_ALL_CHALLENGE_PACKAGES](state, packages) {
    state.allChallengePackages = packages;
  },

  [types.SET_CHALLENGE_PACKAGES_FOR_BUILDER](state, packages) {
    state.challengePackagesForBuilder = packages;
  }
};

export default mutations;
